const NAMESPACE = 'rdc-session';

export default {
  NAMESPACE,
};
